module.exports = new Promise((resolve) => {
        if (window.wkdUiNext) {
          resolve({
            get: (request) => window.wkdUiNext.get(request),
            init: (arg) => {
              try { return window.wkdUiNext.init(arg); } catch (e) {}
            },
          });
          return;
        }
        const script = document.createElement('script');
        script.src = (window.__WKD_REMOTE_JS_MAP__ && window.__WKD_REMOTE_JS_MAP__.wkdUiNext) || 'http://localhost:8009/remoteEntry.js';
        script.onload = () => {
          resolve({
            get: (request) => window.wkdUiNext.get(request),
            init: (arg) => {
              try { return window.wkdUiNext.init(arg); } catch (e) {}
            },
          });
        };
        document.head.appendChild(script);
      });